var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";
import { forwardRef } from "react";

const SvgNotify = (props, ref) => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 64 64",
  width: "1em",
  height: "1em",
  ref: ref
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  d: "M47.81 28.17c-.37-2.58-1.47-5.08-3-7.18-1.89-2.58-4.52-4.51-7.68-5.18-4.98-.71-10.27 0-14.42 3.04-3.53 2.59-5.94 6.56-6.52 10.91-.54 4.03.37 8.68 3.2 11.74 3.24 3.5 8.64 4.37 13.18 3.83 1.4-.17 2.78-.49 4.11-.98.64-.24 1.26-.51 1.87-.83.27-.14 1.48-1.13 1.73-1.07.19.04.78 1.51.9 1.79.46 1.07.84 2.21 1.04 3.36.04.24.24 1.06.66.8.39-.24.6-.84.79-1.23.43-.88.78-1.79 1.12-2.71.99-2.68 1.81-5.44 2.4-8.23.55-2.61 1.02-5.4.63-8.06ZM24 33.73a2.21 2.21 0 1 1 .001-4.421A2.21 2.21 0 0 1 24 33.73Zm8 0a2.21 2.21 0 1 1 .001-4.421A2.21 2.21 0 0 1 32 33.73Zm8 0a2.21 2.21 0 1 1 .001-4.421A2.21 2.21 0 0 1 40 33.73Z"
})));

const ForwardRef = /*#__PURE__*/forwardRef(SvgNotify);
export default ForwardRef;